import {createContext, FC, useContext, useState} from 'react'
import {WithChildren} from '@/_metronic/helpers'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import {FilterProductModifier, initialFilter} from './_models'

type ProductQueryRequestContextProps = {
  state: BaseRequest<FilterProductModifier>
  updateState: (updates: Partial<BaseRequest<FilterProductModifier>>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<ProductQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<BaseRequest<FilterProductModifier>>(initialQueryRequest.state)

  const updateState = (updates: Partial<BaseRequest<FilterProductModifier>>) => {
    const updatedState = {...state, ...updates} as BaseRequest<FilterProductModifier>
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
